export enum ParameterType {
  text,
  numericalRange,
  date
}



// WEBPACK FOOTER //
// ./src/app/models/parameter-type.enum.ts